/**
 *
 * Asynchronously loads the component for UpgradePage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
